import capitalize from "lodash/capitalize";
import toAnalyticsProperties from "../toAnalyticsProperties/index.js";
export const getUserFacingError = error => {
  var _body$errors;

  if (!error.response || error.response.status === undefined || error.response.status >= 500) {
    return 'Unable to contact membership service. Try again later.';
  }

  const {
    response,
    body
  } = error;
  const {
    detail,
    field
  } = (body === null || body === void 0 ? void 0 : (_body$errors = body.errors) === null || _body$errors === void 0 ? void 0 : _body$errors[0]) || {};

  if (response.status === 422) {
    return field ? `${capitalize(field)} ${detail}` : detail;
  }

  return detail;
};
export const parseMemberResponseBody = body => {
  const member = body.members;
  const {
    addresses
  } = body.linked;
  return { ...(body.linked.sessions && {
      session: body.linked.sessions[0]
    }),
    member,
    addresses,
    analyticsProperties: {
      memberProperties: toAnalyticsProperties(member, addresses),
      accountCreateProperties: {
        product: member.application,
        reason: member.action
      }
    }
  };
};
export const parseCreateSessionResponseBody = body => {
  const member = body.linked.members[0];
  const addresses = []; // not included

  return {
    session: body.sessions,
    member,
    addresses,
    analyticsProperties: {
      memberProperties: toAnalyticsProperties(member, addresses),
      accountCreateProperties: {
        product: member.application,
        reason: member.action
      }
    }
  };
};